import { render, staticRenderFns } from "./DadosServico.vue?vue&type=template&id=597a03fb"
import script from "./DadosServico.vue?vue&type=script&lang=js"
export * from "./DadosServico.vue?vue&type=script&lang=js"
import style0 from "./DadosServico.vue?vue&type=style&index=0&id=597a03fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports